module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_c('h1', [_vm._v("User List")]), _vm._v(" "), _c('el-form', {
    ref: "eventForm",
    staticClass: "form-inline",
    attrs: {
      "inline": true,
      "model": _vm.eventForm
    }
  }, [_c('el-form-item', [_c('el-cascader', {
    ref: "eventCascader",
    attrs: {
      "options": _vm.options,
      "show-all-levels": false,
      "placeholder": "Select"
    },
    on: {
      "change": _vm.elCascaderOnlick
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "number"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoginName),
      expression: "showLoginName"
    }],
    attrs: {
      "placeholder": "Login Name"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginName),
      callback: function($$v) {
        _vm.loginName = $$v
      },
      expression: "loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.searching
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "loading": _vm.searching
    },
    on: {
      "click": _vm.onClickAddUser
    }
  }, [_vm._v("Add User")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserTable || _vm.isLoading),
      expression: "showUserTable || isLoading"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": {
        textAlign: 'center'
      },
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "login_name",
      "label": "User Name",
      "fixed": "",
      "fit": "true"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.login_name || '--'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "fixed": "",
      "fit": "true"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.name || '--'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_type",
      "formatter": _vm.statusFormatter,
      "label": "User Type",
      "fit": "true",
      "filters": [{
        text: 'System Admin',
        value: '1'
      }, {
        text: 'Admin',
        value: '2'
      }],
      "filter-method": _vm.filterTag,
      "filter-placement": "bottom-end"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.email || '--'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_ip",
      "label": "Last Login IP"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.last_login_ip || '--'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "login_time",
      "formatter": _vm.dateFormatter,
      "empty-text": "N/A",
      "label": "Last Login Time [as UTC(+00:00)]",
      "fit": "true"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logoff_time",
      "formatter": _vm.dateFormatter,
      "empty-text": "N/A",
      "label": "Last Logout Time [as UTC(+00:00)]",
      "fit": "true"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit User",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.editUser(scope.$index, scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Delete User",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-delete"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteUser(scope.$index, scope.row)
            }
          }
        })], 1)], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-807dc3ba","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserList.vue
// module id = ivq7
// module chunks = 1